export var GlobalConfig = {
    anonymousApiUrl: "",
    siteID: "",
    apiVersion: "v2",
    operatorAuthTokenId: "",
    applicationType: 0
};
export const init = (config) => {
    if (!Object.isFrozen(GlobalConfig)) {
        GlobalConfig = config;
        Object.freeze(GlobalConfig);
    }
    else {
        throw new Error("Already initiliazed");
    }
};
//# sourceMappingURL=init.js.map